import styled from "styled-components";

export const ButtonBase = styled.button<{ $size: string }>`
  display: flex;
  padding: 4px;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
  &:disabled {
    pointer-events: none;
  }
`;

export const Symbol = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
